import {
  getCvAnalysisData,
  addCvDiscrepancy,
  sendMessage,
  concludeDiscrepancy,
  followUpDiscrepancy,
  getAIdiscrepancy
} from "../actions/CvAnalysisAction";
import { createSlice } from "@reduxjs/toolkit";

const addCvDiscrepancySlice = createSlice({
  name: "addCvDiscrepancy",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCvDiscrepancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCvDiscrepancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(addCvDiscrepancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getCvAnalysisDataSlice = createSlice({
  name: "getCvAnalysisData",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCvAnalysisData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCvAnalysisData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getCvAnalysisData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const sendMessageSlice = createSlice({
  name: "sendMessage",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const concludeDiscrepancySlice = createSlice({
  name: "concludeDiscrepancy",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(concludeDiscrepancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(concludeDiscrepancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(concludeDiscrepancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const followUpDiscrepancySlice = createSlice({
  name: "followUpDiscrepancy",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(followUpDiscrepancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(followUpDiscrepancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(followUpDiscrepancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getAIdiscrepancySlice = createSlice({
  name: "getAIdiscrepancy",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAIdiscrepancy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAIdiscrepancy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getAIdiscrepancy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});


export const reducers = {
  getCvAnalysisData: getCvAnalysisDataSlice.reducer,
  addCvDiscrepancy: addCvDiscrepancySlice.reducer,
  sendMessage: sendMessageSlice.reducer,
  concludeDiscrepancy: concludeDiscrepancySlice.reducer,
  followUpDiscrepancy: followUpDiscrepancySlice.reducer,
  getAIdiscrepancy: getAIdiscrepancySlice.reducer,
};
